<button mat-menu-item [disabled]="disabled" (click)="exportRequest()">
  @if (hasIcon) {
    <mat-icon>file_download</mat-icon>
  }
  <span
    >Export
    {{
      extraDescription || availableTemplates?.length
        ? extraDescription + ' CSV'
        : extraDescription
    }}</span
  >
</button>
@if (formId) {
  <button mat-menu-item [disabled]="disabled" (click)="exportFormResponses()">
    <span>Export Form Responses</span>
  </button>
}
@if (availableTemplates?.length) {
  <button
    mat-menu-item
    [disabled]="disabled"
    (click)="exportCustomReportRequest()"
  >
    @if (hasIcon) {
      <mat-icon>file_download</mat-icon>
    }
    <span>Export {{ extraDescription }} Custom Report</span>
  </button>
}

<lib-dialog
  #exportQueuedDialog="dialog"
  header="Export file is processing"
  yesText="GOT IT"
  noText=""
  [width]="450"
  [disableClose]="false"
>
  <ng-template let-clickClose>
    <p>You'll receive an email when it's ready.</p>
    <p>
      We'll keep all exports for 14 days on your
      <a [routerLink]="['/exports']" (click)="close(clickClose)"
        >Export Page.</a
      >
    </p>
  </ng-template>
</lib-dialog>

<lib-dialog
  #customExportDialog="dialog"
  header="Export Custom Report"
  yesText="Export"
  noText="Cancel"
  [width]="450"
  [disableClose]="false"
>
  <ng-template>
    <mat-form-field
      appearance="outline"
      floatLabel="always"
      class="action-dropdown"
    >
      <mat-label>Select custom report template</mat-label>
      <mat-select [formControl]="templateForm?.controls?.template">
        @for (option of availableTemplates; track option.id) {
          <mat-option [value]="option">{{ option.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </ng-template>
</lib-dialog>
